import React, { useEffect } from "react";
import { useAppState } from "@state";
import { LazyMotion } from "framer-motion";

import LgcaAcHeader from "@organisms/LgcaAcHeader";
import Modal from "@organisms/Modal";
import GdprBanner from "@organisms/GdprBanner";
import Themer from "../atoms/Themer";

const createPromise = () => {
  let args;
  // eslint-disable-next-line no-return-assign, no-promise-executor-return
  const promise = new Promise((..._) => (args = _));
  return [promise, ...args];
};
const [promise, resolve] = createPromise();
const loadFeatures = () => promise;

const DefaultLayout = ({ children }) => {
  // load animation features
  useEffect(() => {
    resolve(import("@utils/animationFeatures").then(r => r.domMax));
  }, []);

  const [{ layout }] = useAppState();
  const { theme } = layout;
  // the layout
  return (
    <LazyMotion features={loadFeatures}>
      <div
        id="app_layout"
        className={`lgca-layout w-full transition duration-500 ${
          theme === "light" ? "bg-cream" : "bg-brown"
        }`}
      >
        <LgcaAcHeader />
        {children}

        <GdprBanner />
        <Modal />
        <Themer />
        <div id="fb-root" />
      </div>
    </LazyMotion>
  );
};

export default DefaultLayout;
